module.exports = __webpack_public_path__ + "assets/webgl/art_109_L0.jpg.0ad8d70e.webp";